export const ultimasNoticias = [   
    //    {
    //     "imagen": "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
    //    }
    {
        "imagen" : "/assets/imgs/banner/sigeh.png",
        "url" : "http://sigeh.hidalgo.gob.mx/",
        "titulo" : "Sistema de Información Georreferenciada del Estado de Hidalgo",
        "fecha" : "2025"
    },
    {
    
        "imagen" : "/assets/imgs/banner/laboratoriopp.png",
        "url" : "https://labpoliticas.hidalgo.gob.mx/",
        "titulo" : "Laboratorio Estatal de Políticas Públicas",
        "fecha" : "2026"
    },
    {
        "imagen" : "/assets/imgs/banner/TECI.png",
        "url" : "http://indicadores.hidalgo.gob.mx/",
        "titulo" : "Tablero Estategico de control de Indicadores",
        "fecha" : "2026"
    },
    //{
    //    "imagen" : "/assets/imgs/banner/PAEDH 2024.png",
    //    "url" : "https://u-planeacion.hidalgo.gob.mx/pdf/PAEDH2024.pdf",
     //   "titulo" : "Programa Anual de Evaluación 2024",
    //    "fecha" : "Abril del 2024"
    //},
    //{
   //     "imagen" : "/assets/imgs/banner/tenemos_un_acuerdo.png",
   //     "url" : "http://tenemosunacuerdo.hidalgo.gob.mx/",
   //     "titulo" : "Tenemos un Acuerdo",
   //     "fecha" : "enero del 2023"
   // },
    //{
    //    "imagen" : "https://u-planeacion.hidalgo.gob.mx/assets/imgs/banner/informes_evaluacion.jpeg",
    //    "url" : "https://u-planeacion.hidalgo.gob.mx/assets/pdf/ev/Vinculos.pdf",
    //    "titulo" : "Informes de Evaluación PAED 2023",
    //    "fecha" : "2023"
   // }
    // {
    //     "imagen" : "/assets/imgs/banner/puntosdeacuerdo.png",
    //     "url" : "http://puntosdeacuerdo.hidalgo.gob.mx/",
    //     "titulo" : "Puntos de Acuerdo",
    //     "fecha" : "enero del 2023"
    // },
    // {
    //     "imagen" : "/assets/imgs/banner/primerinforme.png",
    //     "url" : "http://primerinforme.hidalgo.gob.mx/",
    //     "titulo" : "Primer Informe de Gobierno",
    //     "fecha" : "septiembre del 2023"
    // }
]